<template>
  <v-card tile elevation="0">
    <slot></slot>
  </v-card>
</template>

<script>
export default {};
</script>

<style lang="scss">
.v-dialog > .v-card > .v-card__subtitle + .v-card__text,
.v-dialog > .v-card > .v-card__title + .v-card__text {
  padding-top: 16px;
  padding-bottom: 0;
}

.v-card {
  display: flex;
  flex-direction: column;
}

.v-card__title {
  font-size: 1rem;
  line-height: 1rem;
  word-break: initial;
}

.v-card__title + .v-card__subtitle,
.v-card__title + .v-card__text {
  padding-top: 16px;
  padding-bottom: 0;
}

.v-card__text {
  flex-grow: 2;
}
.v-card__actions {
  padding: 8px 16px;
}
</style>